/** 品牌标: 绿色圆角方块里的计算器图标 + 产品名 */
import { Link } from "react-router-dom";
import { Calculator } from "lucide-react";
import { cn } from "@/lib/utils";

export const PRODUCT_NAME = "智能广告制作助手";

export function BrandMark({
  to = "/",
  showName = true,
  subtitle,
  className,
  inverse = false,
}: {
  /** 绿色顶栏上: 白字 + 半透明白底图标 */
  inverse?: boolean;
  to?: string;
  showName?: boolean;
  /** 名字后的小字 (如「管理后台」) */
  subtitle?: string;
  className?: string;
}) {
  return (
    <Link
      to={to}
      className={cn(
        "flex min-w-0 items-center gap-2.5 rounded-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
        className,
      )}
    >
      <span aria-hidden className={cn("flex h-8 w-8 shrink-0 items-center justify-center rounded-lg text-white shadow-sm", inverse ? "bg-white/20 ring-1 ring-white/30" : "bg-brand")}>
        <Calculator className="h-[18px] w-[18px]" strokeWidth={2.25} />
      </span>
      {showName ? (
        <span className="min-w-0 leading-tight">
          <span className={cn("block truncate text-[17px] font-bold tracking-tight", inverse ? "text-white [text-shadow:0_1px_2px_rgba(0,0,0,0.15)]" : "text-foreground")}>{PRODUCT_NAME}</span>
          {subtitle && <span className={cn("block truncate text-[11px] font-medium", inverse ? "text-white/85" : "text-muted-foreground")}>{subtitle}</span>}
        </span>
      ) : (
        <span className="sr-only">{PRODUCT_NAME}</span>
      )}
    </Link>
  );
}
